import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Activities } from '../../types/Back';
import { useAppDispatch, useAppSelector } from '../../Hooks';
import { countryById } from '../../redux/Actions';
import { AllActivities } from './Activities';

export const Detail = (props: { match: { params: { id: string; }; }; }) => {
  let { id } = props.match.params;
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch<any>(countryById(id));
  }, [dispatch, id]);
  
  let { detail } = useAppSelector((state) => state);
  return (
    <div>
      {
        !detail ? (
          <h1>Loading ...</h1>
        ) : (
          <div className='detail__container' >
            <div className='detail__container__name' >
              <p><b>País: </b>{detail.name}</p>
            </div>
            <div className='detail__container__description' >
              <img src={detail.flags} alt={detail.name} />
              <p><b>Continente: </b>{detail.continents}</p>
              <p><b>Capital: </b>{detail.capital}</p>
              <p><b>Población: </b>{detail.population.toLocaleString()} Hab.</p>
              <p><b>Área: </b>{detail.area} m2</p>
            </div>
            <div className='detail__container__activities' >
              {
                !detail.activities.length ? (
                  <p><b>{detail.name}</b> aún no cuenta con actividades</p>
                ) : (
                  detail.activities.map((el: Activities) => {
                    return (
                      <div key={el.id} >
                        <AllActivities
                          key={el.id}
                          id={el.id}
                          name={el.name}
                          difficulty={el.difficulty}
                          duration={el.duration}
                          season={el.season}
                        />
                      </div>
                    );
                  })
                )
              }
            </div>
            <div className="detail__container__button">
              <Link to={'/home'} >
                <button>Regresar</button>
              </Link>
            </div>
          </div>
        )
      }
    </div>
  );
}
